export default "__VITE_PUBLIC_ASSET__4ee164af__"